import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Noise } from "@/components/Noise";
import { Header } from "@/components/Header";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Catalog from "@/pages/Catalog";
import PersonDetail from "@/pages/PersonDetail";
import Admin from "@/pages/Admin";
import AuthCallback from "@/auth/AuthCallback";
import { ProtectedRoute } from "@/auth/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // Process OAuth return FIRST (session_id lives in the URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <SmoothScroll>
        <Routes>
          <Route path="/" element={<Catalog />} />
          <Route path="/person/:id" element={<PersonDetail />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </SmoothScroll>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Noise />
      <BrowserRouter>
        <LanguageProvider>
          <AppRouter />
        </LanguageProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
